import * as React from 'react';
import {
  Slider,
  Handles,
  Tracks,
  SliderItem,
  GetHandleProps,
  TracksObject
} from 'react-compound-slider';
import { Track, DisabledTrack } from './SliderComponents';
import { DigitalIcon, CapitalIcon } from '../../../assets/icons';
import { i18n } from '../../../i18n';

interface RenderHandleProps {
  handles: SliderItem[],
  getHandleProps: GetHandleProps
}

const renderHandle = ({
  handles,
  getHandleProps
}: RenderHandleProps) => (
  <div className='slider-handles'>
    {handles.map(handle => (
      <div
      key={handle.id}
      className='handle'
      style={{
        left: `${handle.percent}%`,
      }}
      {...getHandleProps(handle.id)}
      />
      ))}
  </div>
);

const renderDisabledHandle = ({
  handles,
  getHandleProps
}: RenderHandleProps) => (
  <div className='slider-handles'>
    {handles.map(handle => (
      <div
        key={handle.id}
        className='handle disabled'
        style={{
          left: `${handle.percent}%`,
        }}
        />
      ))}
  </div>
);

const renderTracks = ({ tracks, getTrackProps }: TracksObject): React.ReactNode => (
  <div className='slider-tracks'>
    {tracks.map(({ id, source, target }) => (
      <Track
        key={id}
        source={source}
        target={target}
        getTrackProps={getTrackProps}
      />
    ))}
  </div>
);

const renderDisabledTracks = ({ tracks, getTrackProps }: TracksObject): React.ReactNode => (
  <div className='slider-tracks'>
    {tracks.map(({ id, source, target }) => (
      <DisabledTrack
        key={id}
        source={source}
        target={target}
        getTrackProps={getTrackProps}
      />
    ))}
  </div>
);

const domain: number[] = [0, 100];

interface SliderProps {
  allocation: number;
  enabled: boolean;
  setAllocation: (x: number) => object;
}

interface SliderState {
  capitalPercent: number;
  digitalPercent: number;
}

class InvChoicesSlider extends React.Component<SliderProps, SliderState> {
  constructor(props: SliderProps) {
    super(props);
    this.state = {
      capitalPercent: props.allocation,
      digitalPercent: 100 - props.allocation
    };
  }

  public componentWillReceiveProps(nextProps: SliderProps) {
    if (nextProps.allocation === this.state.capitalPercent) {
      return;
    }

    this.setState({
      capitalPercent: nextProps.allocation,
      digitalPercent: 100 - nextProps.allocation
    });
  }

  public render() {
    return (
      <div className='investment-choice-wrap'>
        <div className={`percentage percentage-left ${this.props.enabled? '': 'disabled'}`}>
          <h4>{this.state.digitalPercent}%</h4>
          <h6>{i18n.t('tool.inv_choices.digital')}</h6>
          <DigitalIcon />
        </div>
        <Slider
          step={1}
          domain={domain}
          onChange={this.onSliderChange}
          onUpdate={this.onSliderUpdate}
          values={[this.state.digitalPercent]}
          className={`slider-wrap ${this.props.enabled? '': 'disabled'}`}
        >
          <Handles>{ this.props.enabled ? renderHandle : renderDisabledHandle }</Handles>
          <Tracks right={false}>{ this.props.enabled ? renderTracks : renderDisabledTracks }</Tracks>
        </Slider>
        <div className={`percentage percentage-right ${this.props.enabled? '': 'disabled'}`}>
          <h4>{this.state.capitalPercent}%</h4>
          <h6>{i18n.t('tool.inv_choices.capital')}</h6>
          <CapitalIcon />
        </div>
      </div>
    );
  }

  private onSliderChange = (values: ReadonlyArray<number>) => {
    if (!this.props.enabled) {
      return;
    }

    this.props.setAllocation(100 - values[0]);
  };

  private onSliderUpdate = (values: ReadonlyArray<number>) => {
    if (!this.props.enabled) {
      return;
    }

    this.setState({
      capitalPercent: 100 - values[0],
      digitalPercent: values[0]
    });
  }
}

export default InvChoicesSlider;